<template>
    <BModal
        :model-value="modal"
        scrollable
        centered
        @update:modelValue="updateModal"
        no-close-on-backdrop
        size="lg"
    >
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Vendor</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol cols="12">
                    <BFormGroup
                        label="Type *"
                        label-for="type"
                        class="text-start mb-3"
                    >
                        <div class="d-flex gap-3">
                            <BFormRadio v-model="form.type" value="Company" name="type">
                                Company
                            </BFormRadio>
                            <BFormRadio v-model="form.type" value="Individual" name="type">
                                Individual
                            </BFormRadio>
                        </div>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.type.$dirty && v$.form.type.$invalid
                            "
                        >
                            {{ v$.form.type.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            
            <BRow>
                <BCol md="6">
                    <BFormGroup
                        label="Vendor Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name"
                            type="text"
                            id="name"
                            placeholder="Enter Vendor Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty &&
                                    v$.form.name.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name.$dirty && v$.form.name.$invalid
                            "
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol md="6">
                    <BFormGroup
                        label="Person In Charge *"
                        label-for="name_pic"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name_pic"
                            type="text"
                            id="name_pic"
                            placeholder="Enter PIC Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name_pic.$dirty &&
                                    v$.form.name_pic.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name_pic.$dirty && v$.form.name_pic.$invalid
                            "
                        >
                            {{ v$.form.name_pic.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>

            <BRow>
                <BCol md="6">
                    <BFormGroup
                        label="Phone *"
                        label-for="phone"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.phone"
                            type="text"
                            id="phone"
                            placeholder="Enter Phone Number"
                            :class="{
                                'is-invalid':
                                    v$.form.phone.$dirty &&
                                    v$.form.phone.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.phone.$dirty && v$.form.phone.$invalid
                            "
                        >
                            {{ v$.form.phone.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol md="6">
                    <BFormGroup
                        label="Email"
                        label-for="email"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.email"
                            type="email"
                            id="email"
                            placeholder="Enter Email (optional)"
                            :class="{
                                'is-invalid':
                                    v$.form.email.$dirty &&
                                    v$.form.email.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.email.$dirty && v$.form.email.$invalid
                            "
                        >
                            {{ v$.form.email.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>

            <BRow>
                <BCol cols="12">
                    <BFormGroup
                        label="Address"
                        label-for="address"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.address"
                            id="address"
                            placeholder="Enter Address (optional)"
                            rows="3"
                        />
                    </BFormGroup>
                </BCol>
            </BRow>

            <BRow>
                <BCol cols="12">
                    <BFormGroup
                        label="Status *"
                        label-for="status"
                        class="text-start mb-3"
                    >
                        <BFormSelect v-model="form.status" id="status">
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </BFormSelect>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.status.$dirty && v$.form.status.$invalid
                            "
                        >
                            {{ v$.form.status.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormRadio,
    BFormSelect,
    BFormTextarea
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, email } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "refresh"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); 
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

const formData = {
    type: "Company",
    name: "",
    name_pic: "",
    phone: "",
    email: "",
    address: "",
    status: "Active",
};

const form = reactive({ ...formData });

// Init data if edit
watch(
    () => props.selectedData,
    (newData) => {
        if (newData && Object.keys(newData).length > 0) {
            Object.assign(form, { ...newData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        type: { required: helpers.withMessage("Type is required", required) },
        name: { required: helpers.withMessage("Name is required", required) },
        name_pic: { required: helpers.withMessage("PIC Name is required", required) },
        phone: { required: helpers.withMessage("Phone is required", required) },
        email: { email: helpers.withMessage("Invalid email", email) },
        status: { required: helpers.withMessage("Status is required", required) },
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/vendor/add`,
                form,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("refresh");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/vendor/edit/${props.selectedData.uuid}`,
                form,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("refresh");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    } else {
        toast.error("Please check the form for errors");
    }
};
</script>
